import React from 'react';

import { BottomDrawer, DrawerContentSecondary } from 'uiToolkitV1/BottomDrawer';

import { useBulkActionContext } from '../BulkActions/BulkActionContext';
import { BULK_NOTIFY_SCREENS, useBulkNotifyContext } from './BulkNotifyContext';
import { BulkNotifyOptions } from './screens/BulkNotifyOptions';
import { BulkNotifyResult } from './screens/BulkNotifyResult';

const componentMapping = {
  [BULK_NOTIFY_SCREENS.NOTIFY_OPTIONS]: BulkNotifyOptions,
  [BULK_NOTIFY_SCREENS.RESULT]: BulkNotifyResult,
};

const BulkNotifyDrawer = () => {
  const { screen, isOpen, resetState } = useBulkNotifyContext();
  const { resetSelection } = useBulkActionContext();

  const Child = componentMapping[screen];

  const onClose = () => {
    resetState();
    resetSelection();
  };

  return (
    <BottomDrawer isOpen={isOpen} onClose={onClose}>
      <DrawerContentSecondary height="auto" maxH="90vh">
        <Child onClose={onClose} />
      </DrawerContentSecondary>
    </BottomDrawer>
  );
};

export default BulkNotifyDrawer;
